import React, { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import FromFieldText from '../../atoms/FromFieldText';
import FromFieldDate from "../../atoms/FromFieldDate";
import { saveITMasters, getITMasterInfo } from '../../services/it-depreciation.service';
import { getCompanyProfileList } from '../../services/user.service';
import * as CryptoJS from "crypto-js";

const TEXT_REGEX = /^[a-zA-Z0-9-_ ]{1,255}$/;

function formatDateForMySQL(dateString) {
    if (!dateString) return null;
    const d = new Date(dateString);
    const year = d.getFullYear();
    const month = (`0${d.getMonth() + 1}`).slice(-2); // महीनों को 01-12 फॉर्मेट में करने के लिए
    const day = (`0${d.getDate()}`).slice(-2);       // दिनों को 01-31 फॉर्मेट में करने के लिए

    return `${year}-${month}-${day}`; // रिटर्न करेगा: YYYY-MM-DD
}

function AddITMasters() {

    // States
    const [companyId, setCompanyId] = useState('');
    const [effectiveStartDate, setEffectiveStartDate] = useState('');
    const [effectiveEndDate, setEffectiveEndDate] = useState('');
    const [incomeTaxBlockName, setIncomeTaxBlockName] = useState('');
    const [blockRate, setBlockRate] = useState('');
    const [dobleShiftRate, setDobleShiftRate] = useState('');
    const [tripleShiftRate, setTripleShiftRate] = useState('');
    const [eligibleForESD, setEligibleForESD] = useState(false);

    const [companies, setCompanies] = useState([]);

    // Error States
    const [errMsg, setErrMsg] = useState('');
    const [success, setSuccess] = useState(false);

    const [ErrCompanyId, setErrCompanyId] = useState('');
    const [ErrIncomeTaxBlockName, setErrIncomeTaxBlockName] = useState('');
    const [ErrBlockRate, setErrBlockRate] = useState('');
    const [ErrEffectiveStartDate, setErrEffectiveStartDate] = useState('');
    const [ErrEffectiveEndDate, setErrEffectiveEndDate] = useState('');
    const [ErrDobleShiftRate, setErrDobleShiftRate] = useState('');
    const [ErrTripleShiftRate, setErrTripleShiftRate] = useState('');

    const useQuery = () => new URLSearchParams(useLocation().search);
    const query = useQuery();
    const ITM_ID = query.get('itms_id');

    // Fetch Companies + Edit Data
    useEffect(() => {

        // Always fetch companies list (for both Add and Edit)
        const fetchCompanies = async () => {
            try {
                const EncryptData = CryptoJS.AES.encrypt(
                    JSON.stringify({ authToken: sessionStorage.getItem('LoggedInToken') }),
                    process.env.REACT_APP_ENCRYPT_SECRET_KEY
                ).toString();

                const res = await getCompanyProfileList({ token: EncryptData });
                if (res?.data?.data?.length) {
                    setCompanies(res.data.data);
                }
            } catch (err) {
                console.error("Error fetching companies:", err);
            }
        };

        fetchCompanies();

        // If editing existing record
        if (ITM_ID) {
            try {
                const decryptedBytes = CryptoJS.AES.decrypt(
                    ITM_ID.replace(/ /g, '+'),
                    process.env.REACT_APP_ENCRYPT_SECRET_KEY
                );
                const decrypt_data = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
                const decryptITM_ID = decrypt_data.itm_id;

                getITMasterData(decryptITM_ID);
            } catch (err) {
                console.error("Decryption error:", err);
            }
        } else {
            resetForm(); // Clear form for new entry
        }

    }, [ITM_ID]);

    // Fetch existing IT Master Data for Edit
    const getITMasterData = (decryptITM_ID) => {
        const EncryptData = CryptoJS.AES.encrypt(
            JSON.stringify({
                param_data: { itm_id: decryptITM_ID },
                authToken: sessionStorage.getItem('LoggedInToken'),
            }),
            process.env.REACT_APP_ENCRYPT_SECRET_KEY
        ).toString();

        const oData1 = { token: EncryptData };

        getITMasterInfo(oData1).then((res) => {
            if (res?.data?.data?.length > 0) {
                const itMasterInfo = res.data.data[0];

                setCompanyId(itMasterInfo.company_id || '');
                setIncomeTaxBlockName(itMasterInfo.block_name || '');
                setBlockRate(itMasterInfo.block_rate || '');
                setDobleShiftRate(itMasterInfo.double_shift_rate || '');
                setTripleShiftRate(itMasterInfo.triple_shift_rate || '');

                // Handle Dates
                setEffectiveStartDate(itMasterInfo?.effective_from ? new Date(itMasterInfo.effective_from) : null);
                setEffectiveEndDate(itMasterInfo?.effective_till ? new Date(itMasterInfo.effective_till) : null);

                // Handle ESD (Yes/No)
                const esdValue = String(itMasterInfo?.is_eligible_for_esd || '').toLowerCase();
                setEligibleForESD(esdValue === 'yes' || esdValue === '1' || esdValue === 'true');

            } else {
                setErrMsg("No record found.");
            }
        }).catch((error) => {
            console.error("Error fetching IT Master data:", error);
            setErrMsg("Unable to fetch record details.");
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        let isValid = true;

        if (!companyId) {
            setErrCompanyId('Company is required');
            isValid = false;
        } else setErrCompanyId('');

        if (!TEXT_REGEX.test(incomeTaxBlockName)) {
            setErrIncomeTaxBlockName('Income Tax Block Name is required');
            isValid = false;
        } else setErrIncomeTaxBlockName('');

        if (!effectiveStartDate) {
            setErrEffectiveStartDate('Effective Start Date is required');
            isValid = false;
        } else setErrEffectiveStartDate('');

        /*if (!effectiveEndDate) {
            setErrEffectiveEndDate('Effective End Date is required');
            isValid = false;
        } else setErrEffectiveEndDate('');*/

        if (!blockRate) {
            setErrBlockRate('Block Rate is required');
            isValid = false;
        } else if (!/^\d*\.?\d+$/.test(blockRate)) {
            setErrBlockRate('Block Rate must be numeric only');
            isValid = false;
        } else setErrBlockRate('');

        if (!dobleShiftRate) {
            setErrDobleShiftRate('Double Shift Rate is required');
            isValid = false;
        } else if (!/^\d*\.?\d+$/.test(dobleShiftRate)) {
            setErrDobleShiftRate('Double Shift Rate must be numeric only');
            isValid = false;
        } else setErrDobleShiftRate('');

        if (!tripleShiftRate) {
            setErrTripleShiftRate('Triple Shift Rate is required');
            isValid = false;
        } else if (!/^\d*\.?\d+$/.test(tripleShiftRate)) {
            setErrTripleShiftRate('Triple Shift Rate must be numeric only');
            isValid = false;
        } else setErrTripleShiftRate('');

        if (isValid) {
            saveData();
        }
    };

    const saveData = () => {
        try {
            let obj = {};

            if (ITM_ID) {
                // Edit Mode
                const decryptedBytes = CryptoJS.AES.decrypt(
                    ITM_ID.replace(/ /g, '+'),
                    process.env.REACT_APP_ENCRYPT_SECRET_KEY
                );
                const decrypt_data = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
                const decryptITM_ID = decrypt_data.itm_id;

                obj = {
                    itms_id: decryptITM_ID,
                    company_id: companyId,
                    block_name: incomeTaxBlockName,
                    block_rate: blockRate,
                    effective_from: formatDateForMySQL(effectiveStartDate),
                    effective_till: formatDateForMySQL(effectiveEndDate),
                    double_shift_rate: dobleShiftRate,
                    triple_shift_rate: tripleShiftRate,
                    created_by: sessionStorage.getItem('LoggedInUserId'),
                    is_eligible_for_esd: eligibleForESD ? "Yes" : "No",
                };
            } else {
                // Insert Mode
                obj = {
                    company_id: companyId,
                    block_name: incomeTaxBlockName,
                    block_rate: blockRate,
                    effective_from: formatDateForMySQL(effectiveStartDate),
                    effective_till: formatDateForMySQL(effectiveEndDate),
                    double_shift_rate: dobleShiftRate,
                    triple_shift_rate: tripleShiftRate,
                    created_by: sessionStorage.getItem('LoggedInUserId'),
                    is_eligible_for_esd: eligibleForESD ? "Yes" : "No",
                };
            }

            const encryptData = CryptoJS.AES.encrypt(
                JSON.stringify({
                    param_data: obj,
                    authToken: sessionStorage.getItem('LoggedInToken')
                }),
                process.env.REACT_APP_ENCRYPT_SECRET_KEY
            ).toString();

            saveITMasters({ token: encryptData })
                .then(res => {
                    if (res?.data?.success) {
                        setSuccess(res.data.message || "Record saved successfully");
                        setErrMsg('');
                        resetForm();
                    } else {
                        setErrMsg(res.data.message || "Operation failed");
                        setSuccess(false);
                    }
                })
                .catch(err => {
                    console.error(err);
                    setErrMsg("Failed to save record");
                    setSuccess(false);
                });

        } catch (err) {
            console.error(err);
            setErrMsg("Something went wrong");
            setSuccess(false);
        }
    };

    const resetForm = () => {
        setCompanyId('');
        setIncomeTaxBlockName('');
        setBlockRate('');
        setEffectiveStartDate('');
        setEffectiveEndDate('');
        setDobleShiftRate('');
        setTripleShiftRate('');
        setEligibleForESD(false);
        setErrMsg('');
    };

    return (
        <div className="container">
            <div className="row">
                <div className="col-6">
                    <h5>{ITM_ID ? "Edit IT Master" : "Add IT Master"}</h5>
                </div>
            </div>

            {success && (
                <div className="alert alert-success mt-3">
                    <i className="bi bi-check-circle-fill"></i> {success}
                </div>
            )}

            {errMsg && (
                <div className="alert alert-danger mt-3">
                    <i className="bi bi-exclamation-triangle-fill"></i> {errMsg}
                </div>
            )}

            <form onSubmit={handleSubmit} className="mt-4">

                {/* Company Dropdown */}
                <div className="row mb-3">
                    <div className="col-3">
                        <label>Company <span className="text-danger">*</span></label>
                    </div>
                    <div className="col-3">
                        <select
                            className="form-select"
                            value={companyId}
                            onChange={(e) => setCompanyId(e.target.value)}
                        >
                            <option value="">Select Company</option>
                            {companies.map((option) => (
                                <option key={option.company_id} value={option.company_id}>
                                    {option.company_name}
                                </option>
                            ))}
                        </select>
                        {ErrCompanyId && <small className="text-danger d-block">{ErrCompanyId}</small>}
                    </div>
                </div>

                {/* Income Tax Block Name */}
                <div className="row mb-3">
                    <div className="col-6">
                        <FromFieldText
                            star="*"
                            label="Income Tax Block Name"
                            inputValue={incomeTaxBlockName}
                            setInputValue={setIncomeTaxBlockName}
                            setErrorMsg={ErrIncomeTaxBlockName}
                        />
                    </div>
                </div>

                {/* Block Rate */}
                <div className="row mb-3">
                    <div className="col-6">
                        <FromFieldText
                            star="*"
                            label="Block Rate"
                            inputValue={blockRate}
                            setInputValue={setBlockRate}
                            setErrorMsg={ErrBlockRate}
                        />
                    </div>
                </div>

                {/* Effective Dates */}
                <div className="row mb-3">
                    <div className="col-6">
                        <FromFieldDate
                            label="Effective Date From"
                            inputValue={effectiveStartDate}
                            setInputValue={setEffectiveStartDate}
                            setErrorMsg={ErrEffectiveStartDate}
                        />
                    </div>
                </div>

                <div className="row mb-3">
                    <div className="col-6">
                        <FromFieldDate
                            label="Effective Date Till"
                            inputValue={effectiveEndDate}
                            setInputValue={setEffectiveEndDate}
                            setErrorMsg={ErrEffectiveEndDate}
                        />
                    </div>
                </div>

                {/* ESD Radio Buttons */}
                <div className="row mb-4">
                    <div className="col-6">
                        <div className="d-flex align-items-center">
                            <label className="form-label me-4 mb-0">
                                Is eligible for ESD?
                            </label>
                            <div className="col-md-3"></div>
                            <div className="col-md-1"></div>
                            <div className="col-md-3">
                                <div className="form-check form-check-inline">
                                    &nbsp;&nbsp;&nbsp;<input
                                    type="radio"
                                    className="form-check-input"
                                    name="esdEligible"
                                    id="esdYes"
                                    checked={eligibleForESD === true}
                                    onChange={() => setEligibleForESD(true)}
                                />
                                    <label className="form-check-label" htmlFor="esdYes">Yes</label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <input
                                        type="radio"
                                        className="form-check-input"
                                        name="esdEligible"
                                        id="esdNo"
                                        checked={eligibleForESD === false}
                                        onChange={() => setEligibleForESD(false)}
                                    />
                                    <label className="form-check-label" htmlFor="esdNo">No</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Shift Rates */}
                <div className="row mb-3">
                    <div className="col-6">
                        <FromFieldText
                            star="*"
                            label="Double Shift Rate"
                            inputValue={dobleShiftRate}
                            setInputValue={setDobleShiftRate}
                            setErrorMsg={ErrDobleShiftRate}
                        />
                    </div>
                </div>

                <div className="row mb-3">
                    <div className="col-6">
                        <FromFieldText
                            star="*"
                            label="Triple Shift Rate"
                            inputValue={tripleShiftRate}
                            setInputValue={setTripleShiftRate}
                            setErrorMsg={ErrTripleShiftRate}
                        />
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col-3"></div>
                    <div className="col-6">
                        <button type="submit" className="btn btn-primary btn-sm">
                            {ITM_ID ? "Update" : "Save"}
                        </button>
                    </div>
                    <div className="col-3"></div>
                </div>
            </form>
        </div>
    );
}

export default AddITMasters;